import { Link, useLocation, useNavigate } from "react-router-dom";
import { APP_PRICING_URL } from "@/lib/appUrls";

export const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const scrollToSection = (id: string) => {
    // If we're on the home page, scroll to the section
    if (location.pathname === "/") {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // If we're on a different page, navigate to home with hash
      navigate(`/#${id}`);
    }
  };

  return (
    <footer className="bg-primary/40 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-12 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
          {/* Logo and Description Column */}
          <div className="md:col-span-5 space-y-4">
            <img
              src="/logos/horizontal.png"
              alt="Property Vue Logo"
              className="h-12 w-auto object-contain"
              loading="lazy"
            />
            <p className="text-sm text-white/80 mt-4 max-w-md">
              Job site photo storage with timestamps and search. $20 a month for
              everything.
            </p>
          </div>

          {/* Company Links */}
          <div className="md:col-span-3">
            <h3 className="font-bold text-sm mb-4 md:mb-6">COMPANY</h3>
            <ul className="space-y-3 md:space-y-4">
              <li>
                <button 
                  onClick={() => scrollToSection("features")} 
                  className="text-sm text-white/80 hover:text-white transition-colors"
                >
                  Features
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection("faq")} 
                  className="text-sm text-white/80 hover:text-white transition-colors"
                >
                  FAQ
                </button>
              </li>
              <li>
                <a href={APP_PRICING_URL} className="text-sm text-white/80 hover:text-white transition-colors">
                  Pricing
                </a>
              </li>
              <li>
                <Link to="/blog" className="text-sm text-white/80 hover:text-white transition-colors">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources Links */}
          <div className="md:col-span-3">
            <h3 className="font-bold text-sm mb-4 md:mb-6">RESOURCES</h3>
            <ul className="space-y-3 md:space-y-4">
              <li>
                <a
                  href="mailto:help@propertyvue.io"
                  className="text-sm text-white/80 hover:text-white transition-colors"
                >
                  Contact Us
                </a>
              </li>
              <li>
                <Link to="/info#terms" className="text-sm text-white/80 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/info#privacy" className="text-sm text-white/80 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-white/10">
          <p className="text-sm text-white/80 text-center">© 2026 Property Vue. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};